module.exports = require('../_components/@alife/next-tab/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web-ui@1/node_modules/_@bone_bone-web-ui@1.0.7@@bone/bone-web-ui/lib/tab/index.js
// module id = 2011
// module chunks = 2